<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">无票收入</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">收入类型：</span>
            <Select v-model="incomeType" :datas="incomeTypeOptions" keyName="key" titleName="title"
                    :deletable="true" style="width:140px" @change="loadList"></Select>
            <input type="text" v-model="keyword" placeholder="事由/付款人" class="input-small" @keyup.enter="loadList">
            <Button size="s" @click="loadList">刷新</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">新增</Button>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">批量操作</Button>
            <Button size="s" :disabled="!checkedList.length" @click="generateVoucher">生成凭证</Button>
            <DropdownMenu button @click="triggerIo" :datas="ioMenus" size="s">导入/导出</DropdownMenu>
        </div>
        <div class="h-panel-body">
            <table class="grid" id="ioTable">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="width:100px">日期</th>
                    <th style="min-width:140px">事由</th>
                    <th style="min-width:120px">类型</th>
                    <th style="min-width:110px">结算方式</th>
                    <th style="width:120px;text-align:right">收入金额</th>
                    <th style="width:110px;text-align:right">应交税费</th>
                    <th style="min-width:100px">付款人</th>
                    <th style="min-width:110px">备注</th>
                    <th style="min-width:90px">关联凭证</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked" :disabled="!!item.voucherId"></td>
                    <td>{{item.incomeDate}}</td>
                    <td>{{item.incomeReason}}</td>
                    <td>{{item.incomeType}}</td>
                    <td>{{item.settlementType}}</td>
                    <td align="right">{{item.incomeAmount|numFormat}}</td>
                    <td align="right">{{item.taxPayable|numFormat}}</td>
                    <td>{{item.payer}}</td>
                    <td>{{item.remark}}</td>
                    <td class="text-hover">{{item.voucherWord}}{{item.voucherCode||''}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length"><td :colspan="11" class="text-center padding">暂无数据</td></tr>
                <tr class="total" v-if="datas.length">
                    <td :colspan="5" align="center">小计</td>
                    <td align="right">{{sumIncome|numFormat}}</td>
                    <td align="right">{{sumTax|numFormat}}</td>
                    <td :colspan="4"></td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id?'编辑':'新增'}}无票收入</div>
            <Form ref="form" v-width="440" :labelWidth="100" :model="form" :rules="rules">
                <FormItem label="收入日期" prop="incomeDate"><DatePicker v-model="form.incomeDate" format="yyyy-MM-dd"></DatePicker></FormItem>
                <FormItem label="收入金额" prop="incomeAmount"><NumberInput v-model="form.incomeAmount" :precision="2" :min="0"></NumberInput></FormItem>
                <FormItem label="收入事由" prop="incomeReason"><input type="text" v-model="form.incomeReason"></FormItem>
                <FormItem label="应交税费"><NumberInput v-model="form.taxPayable" :precision="2" :min="0"></NumberInput></FormItem>
                <FormItem label="收入类型">
                    <Select v-model="form.incomeType" :datas="incomeTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                </FormItem>
                <FormItem label="结算方式">
                    <Select v-model="form.settlementType" :datas="settlementTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                </FormItem>
                <FormItem label="付款人"><input type="text" v-model="form.payer"></FormItem>
                <FormItem label="附件"><Button size="xs" @click="notOpen('上传附件')">上传</Button></FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit(false)" :loading="loading">保存</Button>
                <Button color="primary" @click="submit(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>

        <import-modal v-model="showImport" title="无票收入导入" templateUrl="/api/invoice-non-income/template"
                      :import-fn="importNonIncome" @success="loadList"/>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';
import { exportXls } from '../../js/common/export';

const emptyForm = () => ({
    id: null, incomeDate: new Date(), incomeAmount: 0, incomeReason: '', taxPayable: 0,
    incomeType: '', settlementType: '', payer: '', remark: ''
});

export default {
    name: 'NonIncome',
    components: { ImportModal },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [], p1: ym, p2: ym, keyword: '', incomeType: null,
            incomeTypeOptions: [], settlementTypeOptions: [],
            showForm: false, loading: false, form: emptyForm(),
            showImport: false,
            ioMenus: [
                { title: '模板导入', key: 'openImport' },
                { title: '当前数据导出', key: 'exportCurrent' },
                { title: '全部数据导出', key: 'exportAll' }
            ],
            rules: { required: ['incomeDate', 'incomeAmount', 'incomeReason'] }
        };
    },
    computed: {
        checkAll() { return this.datas.length > 0 && this.datas.every(d => d._checked); },
        checkedList() { return this.datas.filter(d => d._checked); },
        sumIncome() { return this.datas.reduce((s, d) => s + Number(d.incomeAmount || 0), 0); },
        sumTax() { return this.datas.reduce((s, d) => s + Number(d.taxPayable || 0), 0); }
    },
    methods: {
        fmtPeriod(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; },
        fmtDate(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; },
        loadOptions() {
            this.$api.invoice.nonIncome.options().then(({ data }) => {
                this.incomeTypeOptions = (data.incomeTypes || []).map(t => ({ key: t, title: t }));
                this.settlementTypeOptions = (data.settlementTypes || []).map(t => ({ key: t, title: t }));
                if (!this.form.incomeType && this.incomeTypeOptions.length) this.form.incomeType = this.incomeTypeOptions[0].key;
                if (!this.form.settlementType && this.settlementTypeOptions.length) this.form.settlementType = this.settlementTypeOptions[0].key;
                this.loadList();
            });
        },
        loadList() {
            this.$api.invoice.nonIncome.list({
                p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2),
                keyword: this.keyword || undefined
            }).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({ _checked: false }, d));
            });
        },
        add() {
            const f = emptyForm();
            if (this.incomeTypeOptions.length) f.incomeType = this.incomeTypeOptions[0].key;
            if (this.settlementTypeOptions.length) f.settlementType = this.settlementTypeOptions[0].key;
            this.form = f; this.showForm = true;
        },
        edit(item) {
            const f = Object.assign(emptyForm(), item);
            f.incomeDate = item.incomeDate ? new Date(item.incomeDate) : new Date();
            this.form = f; this.showForm = true;
        },
        submit(keep) {
            if (!this.$refs.form.valid().result) return;
            const p = Object.assign({}, this.form);
            p.incomeDate = this.fmtDate(p.incomeDate);
            this.loading = true;
            this.$api.invoice.nonIncome[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false;
                this.loadList();
                this.$Message.success('保存成功');
                if (keep) {
                    const f = emptyForm();
                    if (this.incomeTypeOptions.length) f.incomeType = this.incomeTypeOptions[0].key;
                    if (this.settlementTypeOptions.length) f.settlementType = this.settlementTypeOptions[0].key;
                    this.form = f;
                } else { this.showForm = false; }
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm('确认删除该记录?').then(() => {
                this.$api.invoice.nonIncome.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 条记录?`).then(() => {
                Promise.all(ids.map(id => this.$api.invoice.nonIncome.delete(id))).then(() => this.loadList());
            });
        },
        generateVoucher() {
            const ids = this.checkedList.map(d => d.id);
            this.$api.invoice.nonIncome.generateVoucher(ids).then(({ msg }) => {
                this.$Message.success(msg || '已生成凭证');
                this.loadList();
            });
        },
        toggleAll() { const v = !this.checkAll; this.datas.forEach(d => { if (!d.voucherId) d._checked = v; }); },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); },
        triggerIo(key) { this[key].call(this); },
        openImport() { this.showImport = true; },
        importNonIncome(fd) {
            return this.$api.invoice.nonIncome.importData(fd);
        },
        exportRows() {
            const r = { head: ['日期', '事由', '类型', '结算方式', '收入金额', '应交税费', '付款人', '备注', '关联凭证'], rows: [] };
            (this.datas || []).forEach(item => {
                r.rows.push([item.incomeDate, item.incomeReason, item.incomeType, item.settlementType,
                    Number(item.incomeAmount || 0), Number(item.taxPayable || 0), item.payer, item.remark,
                    `${item.voucherWord || ''}${item.voucherCode || ''}`]);
            });
            return r;
        },
        totalRow() {
            return ['合计', '', '', '', this.sumIncome, this.sumTax, '', '', ''];
        },
        exportCurrent() {
            if (!this.datas.length) { this.$Message('暂无数据可导出'); return; }
            const r = this.exportRows();
            exportXls({
                name: `无票收入_${this.fmtPeriod(this.p1)}至${this.fmtPeriod(this.p2)}`,
                sheets: [{
                    name: '无票收入', head: r.head, rows: r.rows, totalRow: this.totalRow(),
                    widths: [100, 180, 120, 110, 120, 110, 110, 160, 100],
                    types: ['s', 's', 's', 's', 'n', 'n', 's', 's', 's']
                }]
            });
        },
        exportAll() {
            this.$api.invoice.nonIncome.list({ all: 1 }).then(({ data }) => {
                const list = data || [];
                if (!list.length) { this.$Message('暂无数据可导出'); return; }
                const rows = list.map(item => [item.incomeDate, item.incomeReason, item.incomeType, item.settlementType,
                    Number(item.incomeAmount || 0), Number(item.taxPayable || 0), item.payer, item.remark,
                    `${item.voucherWord || ''}${item.voucherCode || ''}`]);
                const d = list.reduce((s, i) => s + Number(i.incomeAmount || 0), 0);
                const t = list.reduce((s, i) => s + Number(i.taxPayable || 0), 0);
                exportXls({
                    name: '无票收入_全部数据',
                    sheets: [{
                        name: '无票收入',
                        head: ['日期', '事由', '类型', '结算方式', '收入金额', '应交税费', '付款人', '备注', '关联凭证'],
                        rows: rows, totalRow: ['合计', '', '', '', d, t, '', '', ''],
                        widths: [100, 180, 120, 110, 120, 110, 110, 160, 100],
                        types: ['s', 's', 's', 's', 'n', 'n', 's', 's', 's']
                    }]
                });
            });
        }
    },
    mounted() { this.loadOptions(); }
};
</script>

<style scoped lang="less">
.filter-bar {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 160px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}

.grid {
    width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
    .total td { background-color: #f5f5f5; font-weight: bold; }
}

.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.text-hover { cursor: pointer; }
</style>
